<template>
    <div id="settingPanel">
        <popup ref="popup" type="center" @close="popClose">
            <div class="setting_panel">
                <div class="panel_title">设置<div class="close_btn" @click="popClose"></div></div>
                <div class="form_item">
                    <div class="form_label">模型</div>
                    <div class="form_content clearfix">
                        <div :class="['btn_option',{'active':model.type==form.model}]" @click="form.model=model.type" v-for="model in modelList" :key="model.type">{{ model.name }}</div>
                    </div>
                </div>
                <div class="form_item">
                    <div class="form_label">图片比例</div>
                    <div class="form_content clearfix">
                        <div :class="['ratio_option',{'active':ratio.key==form.ratio}]" @click="form.ratio=ratio.key" v-for="ratio in ratioList" :key="ratio.key">
                            <div class="ratio_key">{{ ratio.key }}</div>
                            <div class="ratio_label">{{ ratio.label }}</div>
                        </div>
                    </div>
                </div>
                <div class="form_item">
                    <div class="form_label">离谱程度</div>
                    <div class="form_content slide_content">
                        <el-slider v-model="form.outrageous" :marks="stepOutrageousList"></el-slider>
                    </div>
                </div>
                <div class="form_item">
                    <div class="form_label">艺术性</div>
                    <div class="form_content slide_content">
                        <el-slider v-model="form.artistry" :marks="stepArtistryList" :max="1000"></el-slider>
                    </div>
                </div>
                <button class="confirm_btn" @click="confirm">确认</button>
            </div>
        </popup>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    export default {
        components:{popup},
        props:["settingData"],
        data() {
            return {
                form:{
                    model:1,
                    ratio:"1:1",
                    outrageous:0,
                    artistry:10
                },
                modelList:[
                    {type:1,name:"通用"},
                    // {type:2,name:"二次元"}
                ],
                ratioList:[
                    {key: "1:1", ratio1: "512*512", ratio2: "1024*1024", label: "默认"},
                    {key: "16:9", ratio1: "1024*576", ratio2: "1344*768", label: "电脑壁纸"},
                    {key: "9:16", ratio1: "576*1024", ratio2: "768*1344", label: "手机壁纸"},
                    {key: "9:18", ratio1: "512*1024", ratio2: "704*1408", label: "长手机壁纸"},
                ],
                stepArtistryList:{
                  
                    0: '默认',
                    100: '低',
                    500: '中',
                    750: '高',
                    990: '极致'
                },
                stepOutrageousList:{
                    0: '默认',
                    10: '低',
                    50: '中',
                    75: '高',
                    99: '极致'
                }
            }
        },
        created() {
            let form = localStorage.getItem("drawSetting")
            console.log("form=", form)
            if(form){
                this.form = JSON.parse(form)
            }
        },
        methods: {
            show(){
                this.$refs.popup.show();
            },
            popClose(){
                this.$refs.popup.close();
            },
            confirm(){
                // 本地缓存
                localStorage.setItem("drawSetting", JSON.stringify(this.form));
                this.$emit('update:settingData',this.form);
                this.popClose();
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .setting_panel{
        width: 540px;
        padding: 5px 24px 20px;
        background-color: #fff;
        border-radius: 2px;
        .panel_title{
            line-height: 58px;
            font-size: 16px;
            position: relative;
            .close_btn{
                position: absolute;
                width: 22px;
                height: 22px;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url("./img/close.png");
                background-color: #e8e8e8;
                border-radius: 2px;
                top: 18px;
                right: 0;
                cursor: pointer;
            }
        }
        .form_item{
            margin-bottom: 15px;
            .form_label{
                font-size: 12px;
                line-height: 32px;
            }
            .form_content{
                &.slide_content{
                    padding: 0 6px 9px;
                }
                .btn_option{
                    float: left;
                    width: 70px;
                    height: 34px;
                    border: 1px solid #e0e0e5;
                    font-size: 12px;
                    text-align: center;
                    line-height: 32px;
                    margin-right: 10px;
                    cursor:pointer;
                    &.active{
                        color: #fff;
                        background-color: #18a058;
                        border-color: #18a058;
                    }
                }
                .ratio_option{
                    float: left;
                    width: 90px;
                    height: 80px;
                    border-radius: 2px;
                    border: 1px solid #e0e0e5;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                    font-size: 12px;
                    line-height: 20px;
                    color: #777d83;
                    cursor:pointer;
                    &.active{
                        color: #18a058;
                        border-color: #18a058;
                    }
                    .ratio_key{text-align: center;}
                    .ratio_label{
                        text-align: center;
                    }
                }
                /deep/{
                    .el-slider__bar{
                        background-color: #18a058;
                    }
                    .el-slider__button{
                        border-color: #18a058;
                    }
                    .el-slider__marks-text{
                        white-space: nowrap;
                        font-size: 12px;
                        color: #333;
                    }
                }
            }
        }
        .confirm_btn{
            display: block;
            width: 100%;
            height: 34px;
            background-color: #18a058;
            border: none;
            color: #fff;
            font-size: 12px;
            border-radius: 2px;
            margin-top: 10px;
        }
    }
</style>